import type { ContractOtherStatusEnum } from 'gql/graphql';
import { BimContractOtherStatusEnum, WorkOrderPriceStatusEnum } from 'gql/graphql';
import type { BadgePropStatus } from 'uikit';
import { Badge, Text } from 'uikit';

import type { PropsWithChildren } from 'react';
import React, { useMemo } from 'react';

export const badgePropsByStatus: Record<
    WorkOrderPriceStatusEnum | BimContractOtherStatusEnum,
    { badgeStatus?: BadgePropStatus; label: string }
> = {
    [WorkOrderPriceStatusEnum.ContractCondition]: {
        label: 'Условие договора',
    },
    [WorkOrderPriceStatusEnum.Draft]: {
        badgeStatus: 'warning',
        label: 'Черновик',
    },
    [WorkOrderPriceStatusEnum.NewRecord]: {
        badgeStatus: 'normal',
        label: 'Новая запись',
    },
    [WorkOrderPriceStatusEnum.AdditionalCondition]: {
        label: 'Условие ДС',
    },
    [WorkOrderPriceStatusEnum.None]: {
        label: '',
    },
    [BimContractOtherStatusEnum.NewRecord]: {
        badgeStatus: 'normal',
        label: 'Новая запись',
    },
};

export const CodeCell = ({
    status,
    statusLabel = '',
}: PropsWithChildren<{
    status: WorkOrderPriceStatusEnum | BimContractOtherStatusEnum | ContractOtherStatusEnum;
    statusLabel?: string;
}>) => {
    const { badgeStatus, label } = useMemo(() => badgePropsByStatus[status] || {}, [status]);

    return (
        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
            <Badge
                minified
                status={badgeStatus}
                label={label}
                size="s"
                style={{
                    margin: '0 6px 0 4px',
                    flexShrink: 0,
                    boxShadow: !badgeStatus ? 'none' : undefined,
                }}
            />
            {statusLabel && (
                <Text align="right" size="xs">
                    {statusLabel}
                </Text>
            )}
        </div>
    );
};

CodeCell.displayName = 'CodeCell';
